<template>
  <!-- 待外发录入列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="addModifyBtns({})"
          >批量结算录入</el-button
        >
        <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="outgoingToDeKun({})"
        >批量外发同星</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="dc">导出</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="addModifyBtns(scope.row, 1)"
                >结算录入</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "待外发录入列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "BusinessOrder_OutgoingManage", //  页面标识
      reportFiledsNumber: "admin_outgoing_wait_list", // 动态 条件、表头
    };
  },
  mounted() {},
  watch: {},
  methods: {
    // 新增、 修改 、查看
    addModifyBtns({ waybillSplitId }) {
      let ids = [];
      if (waybillSplitId) {
        ids = [waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }
      let query = { ids: JSON.stringify(ids) };
      this.$router.push({
        path: "/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        query,
      });
    },

    outgoingToDeKun({ waybillSplitId }) {
      let ids = [];
      if (waybillSplitId) {
        ids = [waybillSplitId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.waybillSplitId);
        });
      }
      this.$confirm("是将所选运单外发到同星？", "提示：")
          .then(() => {
            let ids = [];
            this.selectTableData.forEach((item) => {
              ids.push(item.waybillSplitId);
            });
            this.$API
                .outgoingToDekun({
                  waybillSplitIds: ids,
                  appId : '6bda86c21ea109ab',
                  apiUrl : 'https://openapi.dekuncn.com/gateway/kps/pro/kms-api/externalOrder/saveOrder',
                })
                .then((res) => {
                  this.$confirm(res.data.result.successMsg + res.data.result.errorMsg || "操作成功", "提示：")
                      .then(() => { });
                  this.getData();
                });
          })
          .catch(() => {});
    },
  },
};
</script>
<style scoped lang="less">
</style>